import { useEffect, useState } from "react";
import { Sun, Moon, Wand2 } from "lucide-react";

const KEY = "awg_preview_bg";
export const readBg = () => localStorage.getItem(KEY) || "auto";

// Auto = pick per image (white for dark art, dark for white art). White / Dark force every tile.
export const useBgPref = () => {
  const [bg, setBg] = useState(readBg);
  useEffect(() => {
    localStorage.setItem(KEY, bg);
    document.documentElement.dataset.previewBg = bg;
    window.dispatchEvent(new Event("awg-bg-change"));
  }, [bg]);
  return [bg, setBg];
};

const OPTS = [["auto", Wand2, "Auto"], ["light", Sun, "White"], ["dark", Moon, "Dark"]];

export const BgToggle = ({ bg, setBg, className = "" }) => (
  <div className={`inline-flex items-center rounded-full border border-zinc-700 bg-[#12141a] p-0.5 ${className}`} role="group" aria-label="Preview background" data-testid="bg-toggle">
    {OPTS.map(([v, Icon, label]) => (
      <button key={v} type="button" onClick={() => setBg(v)} data-testid={`bg-toggle-${v}`} aria-pressed={bg === v} title={v === "auto" ? "Auto: white behind dark art, dark behind white art" : `Preview on ${label.toLowerCase()} shirt`}
        className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold transition-colors ${bg === v ? "bg-[#ff6a13] text-white" : "text-zinc-400 hover:text-white"}`}>
        <Icon size={12} />{label}
      </button>
    ))}
  </div>
);
